import React, { useEffect, useState, useRef } from 'react';
import { BrowserRouter as Router, Route, Link, useParams, useNavigate } from 'react-router-dom';
import { AxiosInstance } from '../components/utils';
import "../css/bootstrap.min.css";
import "../css/animate.min.css";
import "../css/style.css";
import "../css/responsive.css";
import "../css/light-color.css";
import "../css/floatlabel.css";
import "../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Breadcrumbs from '../components/sections/breadcrumbs';
import { Header } from '../components/sections/header';
import ScrollToTop from 'react-scroll-to-top';
import { ToastContainer, toast } from 'react-toastify';
import { Footer } from '../components/sections/footer';
import MainWebFooter from '../components/sections/mainwebsite/mainwebfooter';


function EvtEmergex() {
    const [loading, setLoading] = useState(true);
    const [eventresp, setEventresp] = useState({} as any);
    const navigate = useNavigate();
    const { eventcode } = useParams();
    const queryParams = new URLSearchParams(window.location.search);
    const errmsg = queryParams.get("msg");


    useEffect(() => {
        if (eventcode == null) {
            navigate('/pagenotfound');
        }

        const fetchData = async () => {

            setLoading(true);

            const { data: response } = await AxiosInstance.get('/api/getevent?eventcode=' + eventcode);

            if (response.result != "Success" || response.data?.length == 0) {
                setLoading(false);
                navigate('/pagenotfound');
            }
            setLoading(false);
            setEventresp(response.data[0]);
            console.log(response.data);
        }
        fetchData();
    }, [navigate]);

    if (errmsg) {
        let msg = errmsg;
        if (errmsg == 'PAYMENT_FAILED') {
            msg = 'Payment Failed. Please retry.';
            toast.error(msg);
        }
        else if (errmsg == 'COUPONS_ALREADY_GENERATED') {
            msg = 'Coupons already sent to mail.';
            toast.error(msg);
        }
        else if (errmsg == 'GROUP_PAY_SUCCESS') {
            msg = 'Payment Successful. Please check mail for further details.';
            toast(msg);
        }
    }
    if (loading) {
        return (<div id="preloader">
            <div id="status">
                <div className="spinner"></div>
            </div>
        </div>);
    }
    else {
        return (
            <>
                {eventresp && <div className="antialiased light-vz circle-v ">

                    <Header eventInfo={eventresp} />
                    <h1 className="spacer-section"></h1>
                    <Breadcrumbs
                        items={[
                            { label: eventresp?.name || "Event", href: `/event/${eventresp?.eventcode}` },
                            { label: "EmergeX", href: `/event/${eventresp?.eventcode}/emergex` },
                        ]}
                    />

                    <section className="event-price-sec sec-padding" id="emergex" data-scroll-index="3">
                        <div className="container">
        
                            <div className="sec-title">
                                <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-lightbulb-o fa-stack-1x"></i></span></span>
                                <h3 className="wow fadeInRight" data-wow-duration="500ms">EmergeX: Unveiling Innovation <small>/ Start-up Showcase</small></h3>
                            </div>
                    <div className="row justify-content-center" style={{ marginBottom: "40px" }}>
                                <div className="col-lg-12 text-center">
                                    <a href="https://forms.gle/4vzju5LWHYDnR71J9" target="_blank" rel="noopener noreferrer" className="btn-default">
                                        Apply for EmergeX Start-up Showcase
                                    </a>
                                </div>
                            </div>
                            <div className="emergex-content">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="emergex-description">
                                            <p>
                                                Premium platform for start-ups that are innovating on cutting-edge cybersecurity products and solutions. At EmergeX, we bring together the brightest minds and the most innovative companies in the cybersecurity industry, providing a platform for startups to present their groundbreaking technologies.
                                            </p>
                                            
                                            <p>
                                                EmergeX is conducted on the day of the Annual Conference as a Special Track
                                            </p>
                                            
                                            <div className="emergex-form-section">
                                                <h4>Participation</h4>
                                                <p>
                                                    Submit the participation nomination via Form Link: <a href="https://forms.gle/4vzju5LWHYDnR71J9" target="_blank" rel="noopener noreferrer">https://forms.gle/4vzju5LWHYDnR71J9</a>
                                                </p>
                                                <p>
                                                    Selected start-ups will have to buy the start-up showcase pass to take part in the competition.
                                                </p>
                                            </div>

                                            <div className="emergex-process-section">
                                                <h4>Event Process</h4>
                                                <ul>
                                                    <li>The Start-up will have the opportunity to pitch their innovation and offerings for 5 minutes in front of a distinguished panel of judges and the audience.</li>
                                                    <li>The jury will ask questions for 2 to 3 minutes following each Start-up's presentation.</li>
                                                    <li>After all the presentations, the Jury will decide, upon various parameters, top 3 Start-ups to be declared winners.</li>
                                                </ul>
                                            </div>

                                            <div className="emergex-criteria-section">
                                                <h4>Judging Criteria</h4>
                                                <p>The parameters include, technical strength, business case, innovation and novelty, potential of the idea among others.</p>
                                            </div>

                                            <div className="emergex-facilities-section" style={{ marginBottom: "40px" }}>
                                                <h4>Additional Facilities</h4>
                                                <p>EmergeX can avail other facilities such as booth space, branding etc. at a discounted price.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-12 text-center">
                                        <a href="https://forms.gle/4vzju5LWHYDnR71J9" target="_blank" rel="noopener noreferrer" className="btn-default">
                                            Apply for EmergeX Start-up Showcase
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <MainWebFooter />
                    <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
                    <ToastContainer position="bottom-right" />
                </div>}
            </>
        );
    }
}
export default EvtEmergex;